/* The homepage header overlays the hero; all other pages use solid chrome.
   DMElement owns listener/observer cleanup during theme-editor replacements. */
(function () {
  'use strict';
  if (customElements.get('dm-header-shell')) return;

  class DMHeaderShell extends DMElement {
    init() {
      this.header = this.querySelector('.dm-header');
      if (!this.header || !this.bool('homepage')) return;
      this.threshold = 0;
      const update = () => {
        const menuOpen = !!this.header.querySelector('details[open]');
        this.header.dataset.transparent = String(!menuOpen && window.scrollY < this.threshold);
      };
      const measure = () => {
        this.closest('.shopify-section').style.setProperty(
          '--dm-overlay-header-h', `${this.getBoundingClientRect().height}px`
        );
        // Measure the visual, not the whole hero: on mobile the copy card
        // sits below the media and must not extend the transparent interval.
        if (this.heroMedia) {
          const rect = this.heroMedia.getBoundingClientRect();
          this.threshold = window.scrollY + rect.top + rect.height / 2;
        } else {
          this.threshold = 0;
        }
        update();
      };
      this.on(window, 'scroll', () => this.frame(update), { passive: true });
      this.on(window, 'pageshow', measure);
      this.on(window, 'resize', () => this.frame(measure), { passive: true });
      // Native toggle does not bubble; capture covers desktop dropdowns,
      // the mobile drawer, keyboard activation and programmatic closes.
      this.on(this.header, 'toggle', update, { capture: true });
      const observer = new ResizeObserver(measure);
      observer.observe(this);
      this.track(observer);
      const findHero = () => {
        if (this.heroMedia) observer.unobserve(this.heroMedia);
        this.heroMedia = document.querySelector('#MainContent .dm-hero__media');
        if (this.heroMedia) observer.observe(this.heroMedia);
        measure();
      };
      findHero();
      this.on(document, 'shopify:section:load', findHero);
      this.on(document, 'shopify:section:unload', () => this.frame(findHero));
    }
  }
  customElements.define('dm-header-shell', DMHeaderShell);
})();
